import { useContext } from 'react';
import { PageContext } from '../providers/PageProvider';
import { UsePage } from '../providers/PageProvider/types';

const usePage = (): UsePage => {
  const [state, dispatch] = useContext(PageContext);
  return [state, dispatch];
};

export default usePage;
